// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ts0ZcrzzkHE8jjMYNnFe {
  margin-top: 0.5rem;
  font-weight: 700;
}

.IAR4Ep1S5az7SPr6l4C1 {
  display: grid;
  grid-template-columns: 7fr 2fr;
}
`, "",{"version":3,"sources":["webpack://./src/shared/admin/components/Header/Header.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC","sourcesContent":[".title {\n  margin-top: 0.5rem;\n  font-weight: 700;\n}\n\n.main {\n  display: grid;\n  grid-template-columns: 7fr 2fr;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `Ts0ZcrzzkHE8jjMYNnFe`,
	"main": `IAR4Ep1S5az7SPr6l4C1`
};
export default ___CSS_LOADER_EXPORT___;
